<template>
  <BaseCustomizeMetal componentCode="C" />
</template>
<script>
import BaseCustomizeMetal from "@/components/customizeMetal/traditionalMetal/BaseCustomizeMetal/index.vue";
export default {
  name: "CustomizeMetalC",
  components: {
    BaseCustomizeMetal,
  },
};
</script>
<style scoped lang="scss">
::v-deep {
  .metal-text {
    top: 116px;
    left: 127px;
    @include betweenTableTablePro {
      top: 80px;
      left: 78px;
    }
    @include table {
      top: 63px;
      left: 52px;
    }
    @include phone {
      top: 53px;
      left: 38px;
    }
  }
  .templeName {
    height: 31px;
    width: 235px;
    .textContainer {
      width: 235px;
    }
  }
  .godName {
    width: 247px;
    height: 55px;
    .textContainer {
      width: 247px;
    }
  }
  .gift {
    width: 164px;
    height: 33px;
    margin: 0 0 auto auto;
    .textContainer {
      width: 164px;
    }
  }
  .respect {
    position: absolute;
    bottom: 5px;
    left: 15px;
  }
}
</style>
